import React, { Component, createRef } from 'react'
import Fuse from 'fuse.js'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { ListGroup, ListGroupItem, Button } from 'reactstrap'
import { required } from '../../../../utilities/validators'
import FormattedMessage from '../../../../components/FormattedMessage/FormattedMessage'
import { claimActions } from '../../../../redux/actions'

import './SearchInput.scss'

class SearchInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      query: '',
      search: true,
      retailerResults: [],
    }
    this.textInput = createRef()
  }

  fuseSearch = () => {
    const { query } = this.state
    const { response } = this.props

    const fuse = new Fuse(response.retailers, {
      keys: ['name'],
      includeScore: true,
    })
    const results = fuse.search(query)

    this.setState(state => ({
      retailerResults: state.query ? results.map(retailer => retailer.item) : [],
    }))
  }

  onSearch = ({ currentTarget }) => {
    const { updateSurveyFieldResponse, question } = this.props

    this.setState({ query: currentTarget.value }, () => {
      const { search, query } = this.state
      // if search use fuse, else update the other retailer input
      if (search) {
        this.fuseSearch()
      } else {
        updateSurveyFieldResponse(query, question)
      }
    })
  }

  selectRetailer = retailer => {
    const { updateSurveyFieldResponse, question } = this.props

    this.setState(
      {
        query: retailer.name,
        retailerResults: [],
      },
      () => {
        const { query } = this.state
        updateSurveyFieldResponse(query, question)
      }
    )
  }

  onOther = () => {
    this.setState({ search: false }, () => {
      this.onButtonChanged()
    })
  }

  onSearchRetailer = () => {
    this.setState({ search: true }, () => {
      this.onButtonChanged()
    })
  }

  onButtonChanged = () => {
    this.textInput.current.focus()
    const { updateSurveyFieldResponse, question } = this.props

    this.setState(
      {
        query: '',
        retailerResults: [],
      },
      () => {
        const { query } = this.state
        updateSurveyFieldResponse(query, question)
      }
    )
  }

  render() {
    const { query, search, retailerResults } = this.state
    return (
      <>
        <div className="row justify-content-start py-2">
          <div className="col-6 col-md-4">
            <Button
              color="dark"
              block
              {...(!search && { outline: true })}
              onClick={this.onSearchRetailer}
              aria-pressed={search}
              aria-label="Search retailer"
            >
              <FormattedMessage id="global.label.retailerSearch" />
            </Button>
          </div>
          <div className="col-6 col-md-4">
            <Button
              color="dark"
              block
              {...(search && { outline: true })}
              onClick={this.onOther}
              aria-pressed={!search}
              aria-label="Other retailer"
            >
              <FormattedMessage id="global.label.retailerOther" />
            </Button>
          </div>
        </div>
        <div className="row justify-content-start py-2">
          <div className="col-12 col-md-8">
            <label htmlFor="Search" className="amd-input-label">
              <FormattedMessage id="global.label.retailerSearch" />
            </label>
            <input
              className="form-control amd-text-input"
              type="text"
              id="Search"
              name="Search"
              value={query}
              onChange={this.onSearch}
              // eslint-disable-next-line react/no-unknown-property
              validate={[required]}
              ref={this.textInput}
              aria-label="Retailer search input"
              aria-describedby="retailer-search-help"
              autoComplete="off"
            />
            <small id="retailer-search-help" className="form-text text-muted">
              <FormattedMessage id="global.label.retailerSearchHelp" />
            </small>
          </div>
        </div>
        {search && retailerResults.length > 0 && query.length > 0 && (
          <div className="row justify-content-start py-2">
            <div className="col-12 col-md-8">
              <ListGroup>
                {retailerResults.slice(0, 10).map(retailer => (
                  <ListGroupItem
                    key={retailer.id}
                    onClick={() => this.selectRetailer(retailer)}
                    style={{ fontWeight: 'normal' }}
                    tag="a"
                    action
                    role="option"
                    tabIndex={0}
                    aria-label={retailer.name}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        this.selectRetailer(retailer)
                      }
                    }}
                  >
                    {retailer.name}
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
          </div>
        )}
      </>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  updateSurveyFieldResponse: (...args) => dispatch(claimActions.updateSurveyFieldResponse(...args)),
})

const connectSearchInput = connect(null, mapDispatchToProps)(SearchInput)

export default reduxForm({ form: 'SearchInput' })(connectSearchInput)
